import {
  VarnishContext
} from "./chunk-BDRB3LP3.js";

// src/components/Footer.tsx
import { Link, styled } from "@mui/material";
import React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var StyledFooter = styled(({ backgroundColor, isContrast, layout, ...rest }) => /* @__PURE__ */ jsx("footer", { ...rest }))`
    padding: ${({ theme }) => theme.spacing(3)};
    color: ${({ isContrast, theme }) => isContrast ? theme.palette.common.white : theme.palette.common.black};
    text-align: ${({ layout }) => layout !== "left-aligned" ? "center" : null};
    background-color: ${({ backgroundColor, isContrast, theme }) => backgroundColor ? backgroundColor.hex : isContrast ? theme.paletteExtended.background.dark.hex : theme.palette.common.white};
`;
function FooterLinkSeparator() {
  return /* @__PURE__ */ jsx(React.Fragment, { children: " | " });
}
function PrivacyLink(props) {
  return /* @__PURE__ */ jsx(Link, { variant: props.variant, href: "https://allenai.org/privacy-policy", children: "Privacy Policy" });
}
function TermsOfUseLink(props) {
  return /* @__PURE__ */ jsx(Link, { variant: props.variant, href: "https://allenai.org/terms", children: "Terms of Use" });
}
function BusinessConductLink(props) {
  return /* @__PURE__ */ jsx(Link, { variant: props.variant, href: "https://allenai.org/business-code-of-conduct", children: "Business Code of Conduct" });
}
function AI2TermsAndConditionsAllLinks(props) {
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(PrivacyLink, { variant: props.variant }),
    /* @__PURE__ */ jsx(FooterLinkSeparator, {}),
    /* @__PURE__ */ jsx(TermsOfUseLink, { variant: props.variant }),
    /* @__PURE__ */ jsx(FooterLinkSeparator, {}),
    /* @__PURE__ */ jsx(BusinessConductLink, { variant: props.variant })
  ] });
}
function AI2CopyrightLink(props) {
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(Link, { variant: props.variant, href: "https://allenai.org", children: "\xA9 The Allen Institute for Artificial Intelligence" }),
    " ",
    "- All Rights Reserved"
  ] });
}
function Footer(props) {
  return /* @__PURE__ */ jsx(VarnishContext.Consumer, { children: ({ layout }) => /* @__PURE__ */ jsx(
    StyledFooter,
    {
      className: props.className,
      layout,
      backgroundColor: props.backgroundColor,
      isContrast: props.variant === "dark",
      children: props.children ? props.children : /* @__PURE__ */ jsxs("span", { children: [
        /* @__PURE__ */ jsx(AI2CopyrightLink, { variant: props.variant }),
        /* @__PURE__ */ jsx(FooterLinkSeparator, {}),
        /* @__PURE__ */ jsx(AI2TermsAndConditionsAllLinks, { variant: props.variant })
      ] })
    }
  ) });
}

export {
  FooterLinkSeparator,
  PrivacyLink,
  TermsOfUseLink,
  BusinessConductLink,
  AI2TermsAndConditionsAllLinks,
  AI2CopyrightLink,
  Footer
};
//# sourceMappingURL=chunk-UAB26WLR.js.map